import { translate } from '@gig/magic-common';
import { ValidationDisplay, required, minLength } from '@gig/magic-form-builder';

function password(fieldConfig) {
    return {
        id: 'password',
        component: 'magic-ui-peek-password',
        isDataField: true,
        testId: 'password',
        properties: {
            'placeholder': translate('login.password.placeholder'),
            'unmask-password': fieldConfig.unmaskPassword,
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('login.password.error', {
                    passwordMinLength: fieldConfig.passwordMinLength,
                }),
            },
            {
                name: 'min-length',
                fn: minLength(fieldConfig.passwordMinLength),
                message: translate('login.password.error', {
                    passwordMinLength: fieldConfig.passwordMinLength,
                }),
            },
        ],
    };
}

export { password };
